import React from "react";
import useEffectSkipFirst from "../../hooks/useEffectSkipFirst";
import {
    useBeforeUnload,
    unstable_useBlocker as useBlocker
} from "react-router-dom";
import {useEffect, useCallback, useRef} from "react";

function useChangeChecker(shouldPreventLeave) {
    // this hook handles form changes. If change occurs, it colors background of appropriate field.
    // Also, it makes sure that if there are any changes, user is warned before leaving the page.

    const [changeCheckReset, setChangeCheckReset] = React.useState(false)
    const [changed, setChanged] = React.useState(false);
    const changeRef = React.useRef(changeCheckReset);

    usePrompt(changed); //adds useffect to start checking for changes
    useBeforeUnload(
        // prevent leave to external page
        useCallback(
            (event) => {
                if (changed) {
                    event.preventDefault();
                    event.returnValue = "";
                }
            },
            [changed]
        ),
        {capture: true}
    );

    function leaveConfirmation() {
        return !window.confirm(
            "Zmeny neboli uložené, skutočne chcete opustiť túto stránku?"
        );
    }

    function usePrompt(hasUnsavedChanges) {
        // handles leaving on react page
        const blocker = useBlocker(hasUnsavedChanges ? leaveConfirmation : false);
        const prevState = useRef(blocker.state);

        useEffect(() => {
            if (blocker.state === "blocked") {
                blocker.reset();
            }
            prevState.current = blocker.state;
        }, [blocker]);
    }

    React.useEffect(() => {
        changeRef.current = changed;
    }, [changed]);

    function indicateChange(value){
        setChanged(value);
    }

    useEffectSkipFirst(() => {
        resetForm();
    }, [changeCheckReset]);

    function resetForm() {
        setChanged(false)
    }
    return [changeCheckReset, setChangeCheckReset, changed, indicateChange]
}

export default useChangeChecker;